import { __decorate } from "tslib";
import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import { SupportDesignModule } from 'src/Foundation/Design/app';
import { SharedModule } from 'src/shared';
import { SerialNumberLocatorSpotController } from './serial-number-locator-spot/serial-number-locator-spot.controller';
var moduleId = 'gn.audio.support.serialnumberlocator';
var legacyModuleId = moduleId + ".legacy";
module(legacyModuleId, [])
    .controller('SerialNumberLocatorSpotController', SerialNumberLocatorSpotController);
var SerialNumberLocatorModule = (function () {
    function SerialNumberLocatorModule() {
    }
    SerialNumberLocatorModule = __decorate([
        NgModule({
            declarations: [],
            id: moduleId,
            imports: [SupportDesignModule, legacyModuleId, SharedModule],
            providers: [],
        })
    ], SerialNumberLocatorModule);
    return SerialNumberLocatorModule;
}());
export { SerialNumberLocatorModule };
